import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { planAPI } from '../../services/api';
import toast from 'react-hot-toast';

export const fetchPlans = createAsyncThunk('plans/fetchPlans', async (_, { rejectWithValue }) => {
  try {
    const response = await planAPI.getPlans();
    return response.data.plans;
  } catch (error) {
    return rejectWithValue(error.response?.data?.message || 'Failed to fetch plans');
  }
});

export const createPlan = createAsyncThunk('plans/createPlan', async (planData, { rejectWithValue }) => {
  try {
    const response = await planAPI.createPlan(planData);
    toast.success('Plan created successfully!');
    return response.data.plan;
  } catch (error) {
    const message = error.response?.data?.message || 'Failed to create plan';
    toast.error(message);
    return rejectWithValue(message);
  }
});

export const updatePlan = createAsyncThunk('plans/updatePlan', async ({ id, data }, { rejectWithValue }) => {
  try {
    const response = await planAPI.updatePlan(id, data);
    toast.success('Plan updated successfully!');
    return response.data.plan;
  } catch (error) {
    const message = error.response?.data?.message || 'Failed to update plan';
    toast.error(message);
    return rejectWithValue(message);
  }
});

export const deletePlan = createAsyncThunk('plans/deletePlan', async (id, { rejectWithValue }) => {
  try {
    await planAPI.deletePlan(id);
    toast.success('Plan deleted successfully!');
    return id;
  } catch (error) {
    const message = error.response?.data?.message || 'Failed to delete plan';
    toast.error(message);
    return rejectWithValue(message);
  }
});

const planSlice = createSlice({
  name: 'plans',
  initialState: {
    items: [],
    loading: false,
    error: null,
    selectedPlan: null,
  },
  reducers: {
    clearError: (state) => { state.error = null; },
    setSelectedPlan: (state, action) => { state.selectedPlan = action.payload; },
    clearSelectedPlan: (state) => { state.selectedPlan = null; },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPlans.pending, (state) => { state.loading = true; state.error = null; })
      .addCase(fetchPlans.fulfilled, (state, action) => { state.loading = false; state.items = action.payload; })
      .addCase(fetchPlans.rejected, (state, action) => { state.loading = false; state.error = action.payload; })
      .addCase(createPlan.fulfilled, (state, action) => { state.items.unshift(action.payload); })
      .addCase(updatePlan.fulfilled, (state, action) => {
        const index = state.items.findIndex(item => item.id === action.payload.id);
        if (index !== -1) state.items[index] = action.payload;
      })
      .addCase(deletePlan.fulfilled, (state, action) => {
        state.items = state.items.filter(item => item.id !== action.payload);
      });
  },
});

export const { clearError, setSelectedPlan, clearSelectedPlan } = planSlice.actions;
export const selectPlans = (state) => state.plans.items;
export const selectPlansLoading = (state) => state.plans.loading;
export const selectSelectedPlan = (state) => state.plans.selectedPlan;
export default planSlice.reducer;
